export const getSeverityColour = (value: number) => {
  if (value < 0.25) {
    return "error";
  } else if (value < 0.75) {
    return "warning";
  } else {
    return "success";
  }
};
